export const LOGIN = "/";
export const PODCASTS = "/podcasts"